import React from "react";
import { Container, Title } from "./styled";
import Button from "../ReUsableComponents/IconButton";
import MemberIcon from "@mui/icons-material/PersonOutlineOutlined";
import LabelIcon from "@mui/icons-material/LabelOutlined";
import CheckIcon from "@mui/icons-material/LibraryAddCheckOutlined";
import DateIcon from "@mui/icons-material/ScheduleOutlined";
import AttachmentIcon from "@mui/icons-material/AttachFileOutlined";
import CoverIcon from "@mui/icons-material/TableChartOutlined";
import BasePopover from "../ReUsableComponents/BasePopover";
import MembersPopover from "../Popovers/Members/MembersPopover";
import LabelsPopover from "../Popovers/Labels/LabelsPopover";
import ChecklistPopover from "../Popovers/Checklist/ChecklistPopover";
import DatePopover from "../Popovers/Date/DatePopover";
import DataPreEntregaPopover from "../Popovers/DataPreEntrega/DataPreEntregaPopover";
import DataEntregaPopover from "../Popovers/DataEntrega/DataEntregaPopover";
import DataRevisao1Popover from "../Popovers/DataRevisao1/DataRevisao1Popover";
import DataRevisao2Popover from "../Popovers/DataRevisao2/DataRevisao2Popover";
import AddAttachmentPopover from "../Popovers/Attachment/AddAttachmentPopover";
import CoverPopover from "../Popovers/Cover/CoverPopover";

const AddToCard = () => {
  const [memberPopover, setMemberPopover] = React.useState(null);
  const [labelPopover, setLabelPopover] = React.useState(null);
  const [checklistPopover, setChecklistPopover] = React.useState(null);
  const [datePopover, setDatePopover] = React.useState(null);
  const [dataPreEntregaPopover, setDataPreEntregaPopover] =
    React.useState(null);
  const [dataEntregaPopover, setDataEntregaPopover] = React.useState(null);
  const [dataRevisao1Popover, setDataRevisao1Popover] = React.useState(null);
  const [dataRevisao2Popover, setDataRevisao2Popover] = React.useState(null);
  const [attachmentPopover, setAttachmentPopover] = React.useState(null);
  const [coverPopover, setCoverPopover] = React.useState(null);
  const [labelsBackArrow, setLabelsBackArrow] = React.useState(false);
  const [labelsTitle, setLabelsTitle] = React.useState("Labels");
  return (
    <Container>
      <Title>Adicionar</Title>

      <Button
        clickCallback={(event) => setMemberPopover(event.currentTarget)}
        title="Membros"
        icon={<MemberIcon fontSize="small" />}
      ></Button>
      {memberPopover && (
        <BasePopover
          anchorElement={memberPopover}
          closeCallback={() => {
            setMemberPopover(null);
          }}
          title="Membros"
          contents={<MembersPopover />}
        />
      )}

      <Button
        clickCallback={(event) => setLabelPopover(event.currentTarget)}
        title="Labels"
        icon={<LabelIcon fontSize="small" />}
      ></Button>
      {labelPopover && (
        <BasePopover
          anchorElement={labelPopover}
          closeCallback={() => {
            setLabelPopover(null);
            setLabelsTitle("Labels");
            setLabelsBackArrow(false);
          }}
          title={labelsTitle}
          backClick={() => {
            setLabelsTitle("Labels");
            setLabelsBackArrow(false);
          }}
          backArrow={labelsBackArrow}
          contents={
            <LabelsPopover
              currentPage={labelsTitle}
              titleCallback={(event) => setLabelsTitle(event)}
              arrowCallback={(event) => {
                setLabelsBackArrow(event);
              }}
            />
          }
        />
      )}

      <Button
        clickCallback={(event) => setChecklistPopover(event.currentTarget)}
        title="Checklist"
        icon={<CheckIcon fontSize="small" />}
      ></Button>
      {checklistPopover && (
        <BasePopover
          anchorElement={checklistPopover}
          closeCallback={() => {
            setChecklistPopover(null);
          }}
          title="Checklist"
          contents={
            <ChecklistPopover
              closeCallback={() => {
                setChecklistPopover(null);
              }}
            />
          }
        />
      )}

      <Button
        clickCallback={(event) => setDatePopover(event.currentTarget)}
        title="Datas"
        icon={<DateIcon fontSize="small" />}
      ></Button>
      {datePopover && (
        <BasePopover
          anchorElement={datePopover}
          closeCallback={() => {
            setDatePopover(null);
          }}
          title="Data"
          contents={
            <DatePopover
              closeCallback={() => {
                setDatePopover(null);
              }}
            />
          }
        />
      )}
      <Button
        clickCallback={(event) => setDataPreEntregaPopover(event.currentTarget)}
        title="Data Pré Entrega"
        icon={<DateIcon fontSize="small" />}
      ></Button>
      {dataPreEntregaPopover && (
        <BasePopover
          anchorElement={dataPreEntregaPopover}
          closeCallback={() => {
            setDataPreEntregaPopover(null);
          }}
          title="Data Pré Entrega"
          contents={
            <DataPreEntregaPopover
              closeCallback={() => {
                setDataPreEntregaPopover(null);
              }}
            />
          }
        />
      )}
      <Button
        clickCallback={(event) => setDataEntregaPopover(event.currentTarget)}
        title="Data Entrega"
        icon={<DateIcon fontSize="small" />}
      ></Button>
      {dataEntregaPopover && (
        <BasePopover
          anchorElement={dataEntregaPopover}
          closeCallback={() => {
            setDataEntregaPopover(null);
          }}
          title="Data Entrega"
          contents={
            <DataEntregaPopover
              closeCallback={() => {
                setDataEntregaPopover(null);
              }}
            />
          }
        />
      )}

      {/* <Button
        clickCallback={(event) => setDataRevisao1Popover(event.currentTarget)}
        title="Data Revisão 1"
        icon={<DateIcon fontSize="small" />}
      ></Button>
      {dataRevisao1Popover && (
        <BasePopover
          anchorElement={dataRevisao1Popover}
          closeCallback={() => {
            setDataRevisao1Popover(null);
          }}
          title="Data Revisão 1"
          contents={
            <DataRevisao1Popover
              closeCallback={() => {
                setDataRevisao1Popover(null);
              }}
            />
          }
        />
      )} */}
      {/* <Button
        clickCallback={(event) => setDataRevisao2Popover(event.currentTarget)}
        title="Data Revisão 2"
        icon={<DateIcon fontSize="small" />}
      ></Button>
      {dataRevisao2Popover && (
        <BasePopover
          anchorElement={dataRevisao2Popover}
          closeCallback={() => {
            setDataRevisao2Popover(null);
          }}
          title="Data Revisão 2"
          contents={
            <DataRevisao2Popover
              closeCallback={() => {
                setDataRevisao2Popover(null);
              }}
            />
          }
        />
      )} */}

      <Button
        clickCallback={(event) => setAttachmentPopover(event.currentTarget)}
        title="Arquivos"
        icon={<AttachmentIcon fontSize="small" />}
      ></Button>
      {attachmentPopover && (
        <BasePopover
          anchorElement={attachmentPopover}
          closeCallback={() => {
            setAttachmentPopover(null);
          }}
          title="Anexar de..."
          contents={
            <AddAttachmentPopover
              closeCallback={() => {
                setAttachmentPopover(null);
              }}
            />
          }
        />
      )}

      <Button
        title="Fundo"
        clickCallback={(event) => setCoverPopover(event.currentTarget)}
        icon={<CoverIcon fontSize="small" />}
      ></Button>
      {coverPopover && (
        <BasePopover
          anchorElement={coverPopover}
          closeCallback={() => {
            setCoverPopover(null);
          }}
          title="Fundo"
          contents={
            <CoverPopover
              closeCallback={() => {
                setCoverPopover(null);
              }}
            />
          }
        />
      )}
    </Container>
  );
};

export default AddToCard;
